import { ActionDropdown, Button } from '@driftt/tide-core'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import React, { useState } from 'react'

import { copyToClipboard } from 'utils'

const TestBotDropdown = ({ onClickEdit, testData, isDisabled }) => {
  const [hasCopiedLink, setHasCopiedLink] = useState(false)

  const { url, slug } = testData

  const getTestLink = () => {
    if (isEmpty(url)) {
      return ''
    }

    if (url.startsWith('https://') || url.startsWith('http://')) {
      return `${url}#${slug}`
    }

    return `https://${url}#${slug}`
  }

  // Right now the action dropdown always flows right so we don't have a lot of space.  Therefore we will truncate the test url.
  const getTestLabel = () => {
    let label = getTestLink()
    if (label.length > 30) {
      label = `${label.slice(0, 30)}...`
    }

    return label
  }

  const handleClickCopy = () => {
    copyToClipboard(getTestLink())
    setHasCopiedLink(true)
  }

  return (
    <>
      {isDisabled ? (
        <Button disabled={true}>Test bot flow</Button>
      ) : (
        <ActionDropdown
          title="Test bot flow"
          className="playbook-editor-test-bot-dropdown"
          tethered
          actions={[
            {
              label: getTestLabel(),
              icon: 'open-new-tab',
              action: () => window.open(getTestLink(), '_blank'),
            },
            {
              label: hasCopiedLink ? 'Copied' : 'Copy test link',
              icon: hasCopiedLink ? 'check' : 'link-1',
              action: handleClickCopy,
            },
            {
              label: 'Test on a new page',
              icon: 'pencil',
              action: onClickEdit,
            },
          ]}
        />
      )}
    </>
  )
}

TestBotDropdown.propTypes = {
  onClickEdit: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default TestBotDropdown
